
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3><div class='qnumber'>{`2`}</div>{`Verlauf der Epidemie`}</h3>
    <p>{`Beim Vergleich des Verlaufs der Covid-Epidemie in der Schweiz und in Schweden stechen zwei Umstände hervor: Schweden testet deutlich weniger und hat mehr Todesfälle. Die Schweiz hat bisher pro Kopf rund doppelt so viele Tests durchgeführt. In Schweden sind fast doppelt soviele Menschen an Covid-19 gestorben.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Stand 24. Mai`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Schweden`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Schweiz`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Infektionen pro Mio. Einwohner`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`3288`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`3553`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Todesfälle pro Mio. Einwohner`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`396`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`220`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Anzahl Tests`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`209’900`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`367’037`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Tests pro Mio. Einwohner`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`20’797`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`42’442`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`R-Wert (13. Mai 2020)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`0.98`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`0.73`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Der schwedische Chef-Epidemiologe Anders Tegnell erklärte gegenüber `}<a parentName="p" {...{
        "href": "https://www.bbc.com/news/world-europe-52704836"
      }}>{`BBC News`}</a>{`: «Die Zahl der Todesfälle hat sich nicht gut entwickelt. Dies liegt zu einem kleinen Teil an unserer Strategie, ist aber hauptsächlich dadurch begründet, dass die Altersheime sich nicht gegen das Virus wehren konnten.» Etwa die Hälfte der Covid-Todesfälle in Schweden stamme aus Alters- und Pflegeheimen – in der Schweiz sind es mit `}<a parentName="p" {...{
        "href": "https://interaktiv.tagesanzeiger.ch/2020/corona-tote-mehrheitlich-aus-altersheimen/"
      }}>{`rund 53%`}</a>{` etwa gleich viele.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;